export const PREFERRED_DEVICE_KEY = 'aiscoreboard.preferredDeviceId';
export const DEVICE_PAIRING_EVENT = 'aiscoreboard-device-pairing-changed';
const PAIRING_PREFIX = 'aiscoreboard.devicePairing.';

export function devicePairingToken(deviceId: string): string | null {
  return typeof window === 'undefined' ? null : window.localStorage.getItem(PAIRING_PREFIX + deviceId);
}

export function preferredPairing(): { deviceId: string; token: string } | null {
  if (typeof window === 'undefined') return null;
  const deviceId = window.localStorage.getItem(PREFERRED_DEVICE_KEY);
  const token = deviceId ? devicePairingToken(deviceId) : null;
  return deviceId && token ? { deviceId, token } : null;
}

export function selectCamera(deviceId: string | null): void {
  if (deviceId) window.localStorage.setItem(PREFERRED_DEVICE_KEY, deviceId);
  else window.localStorage.removeItem(PREFERRED_DEVICE_KEY);
  window.dispatchEvent(new Event(DEVICE_PAIRING_EVENT));
}

export function saveDevicePairing(deviceId: string, token: string): void {
  window.localStorage.setItem(PAIRING_PREFIX + deviceId, token);
  selectCamera(deviceId);
}

export function forgetDevicePairing(deviceId: string): void {
  window.localStorage.removeItem(PAIRING_PREFIX + deviceId);
  if (window.localStorage.getItem(PREFERRED_DEVICE_KEY) === deviceId) selectCamera(null);
  else window.dispatchEvent(new Event(DEVICE_PAIRING_EVENT));
}

export function devicePairingHeaders(): Record<string, string> {
  const paired = preferredPairing();
  return paired ? { 'x-device-pairing': paired.token } : {};
}
